import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, NgZone } from '@angular/core';
import { HomeTabs, Search } from '@local/client-contracts';
import { PopupService } from '@local/ui-infra';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ContextMenuService } from '@shared/components';
import { EventsService } from '@shared/services';
import { KeyboardService } from '@shared/services/keyboard.service';
import { LocalActionsService } from '@shared/services/local-actions.service';
import { RouterService } from '@shared/services/router.service';
import { SessionService } from '@shared/services/session.service';
import { TelemetryHelperService, WorkspacesService } from 'src/app/bar/services';
import { ResultCommandService } from 'src/app/bar/services/commands/result-command.service';
import { HubService } from 'src/app/bar/services/hub.service';
import { ResultsService } from 'src/app/bar/services/results.service';
import { InvokeCommand } from '../../../results/models/invoke-command.model';
import { ResultItem } from '../../../results/models/results-types';
import { WidgetsService } from '../../services/widgets.service';
import { WidgetBaseComponent } from '../widget-base.component';
import { HomeTabsService } from 'src/app/bar/services/home-tabs.service';
import { AvatarListService } from 'src/app/bar/services/avatar-list.service';

@UntilDestroy()
@Component({
  selector: 'actions-widget',
  templateUrl: './actions-widget.component.html',
  styleUrls: ['./actions-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionsWidgetComponent extends WidgetBaseComponent<HomeTabs.Widget> {
  constructor(
    protected elementRef: ElementRef,
    protected hubService: HubService,
    protected cdr: ChangeDetectorRef,
    private telemetryHelperService: TelemetryHelperService,
    protected keyboardService: KeyboardService,
    protected widgetsService: WidgetsService,
    protected resultCommandService: ResultCommandService,
    protected ngZone: NgZone,
    private actionsService: LocalActionsService,
    private resultsService: ResultsService,
    protected session: SessionService,
    protected contextMenuService: ContextMenuService,
    protected workspacesService: WorkspacesService,
    protected popupService: PopupService,
    protected eventsService: EventsService,
    protected routerService: RouterService,
    protected homeTabsService: HomeTabsService,
    protected avatarListService: AvatarListService
  ) {
    super(
      elementRef,
      cdr,
      keyboardService,
      widgetsService,
      ngZone,
      session,
      contextMenuService,
      workspacesService,
      popupService,
      eventsService,
      routerService,
      homeTabsService,
      avatarListService
    );
  }

  loadData() {
    this.isLoading = true;
    this.actionsService.all$.pipe(untilDestroyed(this)).subscribe(async (data) => {
      if (!data) return;
      let first = true;
      this.displayedContext.items = data;
      this.isLoading = first && !this.displayedContext.items.length; // no items could be loaded from cache waiting for second round
      if (first) {
        this.telemetryHelperService.impressionEvent('favorites', <ResultItem[]>this.displayedContext.items, {});
        first = false;
      }

      await this.onResizeChange();
      this.cdr.markForCheck();
    });
  }

  public async onInvoke(data: InvokeCommand, type: Search.ResultType): Promise<void> {
    const eventInfo = { ...data.eventInfo, resources: [{ list: 'actions' }] };
    data = { ...data, eventInfo };
    this.resultCommandService.onInvoke(
      this.displayedContext.items,
      data,
      type,
      'favorites',
      'favorites',
      'favorites',
      this.selectedIndex,
      0
    );
  }
}
